<div class="dropdown relative w-100">
    <div class="flex single-select-container mx-auto mx-auto px-[2.5rem]" [class.disabled]="disabled" (click)="toggleDropdown()">
        <div class="selection-display">
            <span [ngClass]="{'text-muted': !selectedOption}">{{ displayText }}</span>
        </div>
        <div class="controls">
            <button *ngIf="selectedOption && !disabled" type="button" class="btn-clear" (click)="clearSelection($event)"
                title="Clear selection">
                <i class="bi bi-x-circle-fill"></i>
            </button>
            <i *ngIf="!isOpen" class="bi bi-chevron-down"></i>
            <i *ngIf="isOpen" class="bi bi-chevron-up"></i>
        </div>
    </div>
    <div *ngIf="isOpen && !disabled" class="dropdown-menu show w-100 mt-1 p-2 shadow">
        <input type="text" [(ngModel)]="searchTerm" placeholder="Search..." class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary mb-2"
            (click)="$event.stopPropagation()" />
        <div class="options-list overflow-auto">
            <div *ngIf="filteredOptions.length === 0" class="text-gray-500 p-2">No options found</div>
            <div *ngFor="let opt of filteredOptions" class="option-item" [class.active]="selectedOption?.id === opt.id"
                (click)="selectOption(opt)">
                <span>{{ opt.name }}</span>
            </div>
        </div>
    </div>
</div>